import React from 'react'

const ImageImporter = () => {
  console.log("✅ ImageImporter is rendering");

  const handleImageUpload = (e) => {
    // TODO(Phase 2): Implement image import and color reduction - see docs/FEATURES.md
    alert('Image import will be implemented in future updates')
  }

  return (
    <div className="image-importer">
          
          <h2>Import Image</h2>
      <input
        type="file"
        accept="image/png,image/jpeg,image/jpg"
        onChange={handleImageUpload}
      />
      <p style={{ fontSize: '0.85rem', color: 'var(--accent-color)', marginTop: '0.5rem' }}>
        Upload a PNG or JPG to convert to a punch needle pattern.
      </p>
    </div>
  );
}

export default ImageImporter
